import React from 'react';
import AptStartTest from './AptStartSteps';

const Index = () => {
  return (
    <div className='w-full'>
      <AptStartTest />
    </div>
  );
};

export default Index;
